export default "__VITE_ASSET__b43021b7__"